export enum EmployeesContainerTypes {
  EmployeesModalsFacade = 'EmployeesModalsFacade',
}
